// Global configuration for the application
export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.DEV
      ? 'http://localhost:5000'
      : 'https://digital-audit-api.azurewebsites.net',
    endpoints: {
      audit: {
        score: '/audit/score',
        email: '/audit/email',
        pdf: '/audit/pdf',
      },
    },
  },
} as const;

// Helper function to build full API URLs
export const getApiUrl = (endpoint: string): string => {
  // Ensure endpoint starts with '/' if not already present
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${config.api.baseUrl}${normalizedEndpoint}`;
};

// Convenience functions for specific endpoints
export const getAuditApiUrl = {
  score: () => getApiUrl(config.api.endpoints.audit.score),
  email: () => getApiUrl(config.api.endpoints.audit.email),
  pdf: () => getApiUrl(config.api.endpoints.audit.pdf),
};
